import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=733eae53&"
import script from "./LabelSelector.vue?vue&type=script&setup=true&lang=js&"
export * from "./LabelSelector.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports